/* global angular */
(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('dropdown', [function () {
    return {
      template: "\n                <div uib-dropdown dropdown-append-to-body=\"true\">\n                    <button class=\"btn btn-brand-alt\" uib-dropdown-toggle ng-class=\"btnClasses\">\n                        <div style=\"display: inline;\">\n                            <i class=\"fas fa-{{icon}}\" ng-show=\"icon\"></i>\n                            {{ capitalizeLabel ? (inputLabel | capitalize) : inputLabel }}\n                        </div>\n                        <i class=\"fas fa-chevron-down\" style=\"margin-left: 1.5rem;\"></i>\n                    </button>\n                    <ul uib-dropdown-menu role=\"menu\">\n                        <li ng-repeat=\"opt in options\" ng-class=\"{ 'active': opt.toUpperCase() === inputLabel.toUpperCase()}\">\n                            <a ng-click=\"onSelect(opt)\">{{ capitalizeLabel ? (opt | capitalize) : opt }}</a>\n                        </li>\n                    </ul>\n                </div>\n            ",
      scope: {
        capitalizeLabel: '<',
        inputLabel: '<',
        options: '<',
        onSelect: '<',
        icon: '@?',
        iconStyle: '@?',
        btnClasses: '<?' // Optional; expression passed to ngClass on the button
      },
      link: function link(scope) {
        setDefaultProp('iconStyle', 'fas');
        setDefaultProp('icon', '');
        setDefaultProp('capitalizeLabel', true);
        function setDefaultProp(defaultProp, defaultValue) {
          if (angular.isUndefined(scope[defaultProp])) {
            scope[defaultProp] = defaultValue;
          }
        }
      }
    };
  }]);
})();
